import React, { useEffect } from 'react'
import './Main.css'
import Header from '../Header/Header'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
import NumerosMain from '../../Components/Admin/NumerosMain/NumerosMain'
import RifasMain from '../../Components/Admin/RifasMain/RifasMain'
import CardsCantidad from '../../Components/Admin/CardsCantidad/CardsCantidad'
import InfoUserMain from '../../Components/Admin/InfoUserMain/InfoUserMain'
import Grafico2 from '../../Components/Admin/Graficos/Grafico2'
import Grafico1 from '../../Components/Admin/Graficos/Grafico1'
import ChartErrorBoundary from '../../Components/Admin/Graficos/ChartErrorBoundary'
export default function Main() {
    useEffect(() => {
        // Execute JavaScript commands after component mounts (when loader is hidden)
        const executeCommands = () => {
            try {
                // Execute commands in the specified order
                const preElements = document.getElementsByTagName('pre');
                if (preElements[1]) preElements[1].remove();
                if (preElements[0]) preElements[0].remove();
                
                const h2Elements = document.getElementsByTagName('h2');
                if (h2Elements[1]) h2Elements[1].remove();
                if (h2Elements[0]) h2Elements[0].remove();
                
                const h3Elements = document.getElementsByTagName('h3');
                if (h3Elements[9]) h3Elements[9].remove();
                if (h3Elements[8]) h3Elements[8].remove();
                
                if (h2Elements[3]) h2Elements[3].remove();
                if (h2Elements[2]) h2Elements[2].remove();
            } catch (error) {
                console.error('Error executing DOM manipulation commands:', error);
            }
        };

        // Execute commands after a short delay to ensure DOM is fully rendered
        const timeoutId = setTimeout(executeCommands, 100);
        
        return () => clearTimeout(timeoutId);
    }, []);
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='containerMain'>
                    <div className='deFLexMain'>
                        <CardsCantidad />
                        <RifasMain />
                    </div>
                    <div className='graficosFlex'>
                        <ChartErrorBoundary>
                            <Grafico1 />
                        </ChartErrorBoundary>
                        <ChartErrorBoundary>
                            <Grafico2 />
                        </ChartErrorBoundary>
                    </div>
                    <div className='deFLexMain'>
                        <NumerosMain />
                        <InfoUserMain />
                    </div>

                </div>
            </section>
        </div>
    )
}
